import React, { useState } from 'react';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';
// import Loader from '../../../../components/Shared/Loader/Loader';
import { useTranslation } from 'react-i18next';
import AddFiscalYear from './AddFiscalYear';
import useGetGlPeriodsList from '../../../../hooks/Finance/GlPeriods/useGetGlPeriodsList';
import { Link } from 'react-router-dom';
import {type  PeriodsModels } from '../../../../store/Finance/Periods/PeriodsModels';
import UpdateFiscalYear from './UpdateFiscalYear';
import Loading from '../../../../components/Shared/Loader/Loading';
import NtxTable from '../../../../components/DataTable/NtxTable';

const Index = () => {
  const [dataById, setDataById] = useState<PeriodsModels>(); // for sent as props to Update component PeriodsModels

  const { t, i18n } = useTranslation();

  const { PeriodsList, loading, error } = useGetGlPeriodsList();

  const columns = [
    { title: t('FiscalYear'), key: 'Name' },
    { title: t('StartDate'), key: 'Start' },
    { title: t('EndDate'), key: 'Date' },
    { title: t(''), key: 'action', className: 'text-end' },
  ];

  const tableData = PeriodsList?.filter((f) => f.periodYear === null)?.map((item) => {
    let rowClass;

    return {
      Name: i18n.language === 'ar' ? item.name2 : item.name,
      Start: item.startDate.toString(),
      Date: item.endDate.toString(),
      action: (
        <>
          <button
            type="button"
            className="btn btn-sm btn-outline-theme"
            data-bs-toggle="modal"
            data-bs-target="#modalUpdateFiscalYear"
            onClick={() => setDataById(item)}>
            <i className="far fa-lg fa-fw mx-2 fa-edit"></i>
            {t('Button.Edit')}
          </button>
        </>
      ),

      rowClass, // استخدم rowClass هنا
    };
  });

  //____________________________
  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome',
    },
    {
      name: 'FiscalYear',
      link: null,
    },
  ];

  return (
    <div>
      <div className="d-flex align-items-center">
        <Breadcrumb BreadcrumbList={BcrumbList} PageName="FiscalYear" />

        <div className="ms-auto">
          <Link
            to=""
            className="btn me-1 btn-theme"
            data-bs-toggle="modal"
            data-bs-target="#modalAddFiscalYear"
            // onClick={() => setShow(true)}
          >
            <i className="fa fa-plus-circle fa-fw me-1"></i>
            {t('AddFiscalYear')}
          </Link>
        </div>
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=""
              tableClass="table text-nowrap table-hover "
              enableSearch
              showRecordsSelector
            />
          </CardBody>
        </Loading>
      </Card>

      <ModalComponent title={t('AddFiscalYear')} id="modalAddFiscalYear" size="sm">
        {<AddFiscalYear />}
      </ModalComponent>

      <ModalComponent title={t('EditFiscalYear')} id="modalUpdateFiscalYear" size="sm">
        {dataById && <UpdateFiscalYear DataById={dataById} />}
      </ModalComponent>
    </div>
  );
};

export default Index;
